import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import serialize from 'serialize-javascript';

var _excluded = ["data", "name"];
var SerializeData = function SerializeData(_ref) {
  var data = _ref.data,
      name = _ref.name,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return React__default.createElement("script", Object.assign({
    defer: true
  }, props, {
    dangerouslySetInnerHTML: {
      __html: "window._" + name.toUpperCase() + "_ = " + serialize(data)
    }
  }));
};
var getSerializedData = function getSerializedData(name, remove) {
  if (remove === void 0) {
    remove = true;
  }

  var data = window["_" + name.toUpperCase() + "_"];

  if (remove) {
    delete window["_" + name.toUpperCase() + "_"];
  }

  return data;
};

export { SerializeData, getSerializedData };
//# sourceMappingURL=serializeData.esm.js.map
